import _ from '../helper/HelperFunctions';

export default class MobileMenu {
	constructor(mobileTrigger) {
		this.trigger = mobileTrigger;
		this.mobileMenu = this.trigger.parentNode.querySelector('#mobile-menu');
		this.mobileMenuParent = this.mobileMenu.parentNode;
		this.header = document.getElementById('vl-header');
		this.pageWrapper = document.querySelector('.page-wrapper');
		this.scrollPosition;

		this.setEventListeners();
	}

	setEventListeners() {
		// Triggers on mobile
		this.trigger.addEventListener( 'click' , ( e ) => { e.preventDefault() } )
		this.trigger.addEventListener( _.clickEvent() , this.toggleMenu.bind( this ) );

		window.addEventListener('hashchange', ( ) => {
			if( document.body.classList.contains('mobile-menu-open') )
			{
				this.toggleMenu()
			}

			// Alter scroll target
			var target = window.location.hash
				target = target ? document.getElementById( target.substr(1) ) : false

			if( target )
			{
				window.scrollTo({top: target.getBoundingClientRect().top + window.pageYOffset + -100, behavior: 'smooth'})
			}
		})
	}

	toggleMenu( e ) {
		if( e )
		{
			e.preventDefault()
		}
		
		document.body.classList.toggle('mobile-menu-open');
		this.mobileMenu.style.top = this.header.offsetHeight + 'px';
		this.mobileMenu.style.height = `calc(100vh - ${this.header.offsetHeight}px)`;
		document.body.appendChild(this.mobileMenu);
		this.pageWrapper.classList.toggle('popup-window-active');
	}
}